module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-09-ce3cbc575161244b2559709eea26c33d.svg";